import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { signOut } from '../../store/authentication/authenticationActions/authenticationActions';
import { useDispatch } from 'react-redux';

export default () => {
  const dispatch = useDispatch();

  useEffect(() => {
    signOut()(dispatch);
  }, []);

  return <Navigate to="/login/entreprise" replace />;
};
